import React from 'react'
import { Box, Typography } from '@mui/material'
import { ArrowDownward, ArrowUpward } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles((theme: Theme) => ({
    delta: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: theme.spacing(0.5),
    },
    deltaIcon: {
        fontSize: 16,
    },
    deltaText: {
        fontWeight: 500,
        marginLeft: theme.spacing(0.25),
    },
}))

interface DeltaProps {
    delta?: number
}

const Delta = ({ delta }: DeltaProps) => {
    const classes = useStyles()
    const theme = useTheme()

    if (!delta) {
        return null
    }

    const isPositive = delta > 0
    const Icon = isPositive ? ArrowUpward : ArrowDownward
    const sign = isPositive ? '+' : ''
    const color = isPositive ? theme.palette.success.main : theme.palette.error.main

    return (
        <Box component="span" className={classes.delta} style={{ color }}>
            <Icon className={classes.deltaIcon} />
            <Typography variant="caption" component="span" className={classes.deltaText} color="inherit">
                {sign}
                {delta}%
            </Typography>
        </Box>
    )
}


export default Delta